import React, { Component } from 'react';
import { formatVietnameseDate } from '@/utils/helpers';
import moment from 'moment';

class PrintRefusa extends Component {

    render() {
        return (
            <div>
                <div className="print-container">
                    <div className='page-break'>
                        {/* Header */}
                        <div className="header">
                            <div className="header-left">
                                Công ty TNHH Anh Nguyễn Beauty
                                <br />
                                Cơ sở KB, CB: Nha khoa CHINGO
                            </div>
                            <div className="header-center">
                                <div className="header-title">
                                    CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                                    <br />
                                    <span className="subtitle">Độc lập - Tự do - Hạnh phúc</span>
                                </div>
                            </div>
                            <div className="header-right">MS: 41/BV2</div>
                        </div>
                        <h2 className="form-title">
                            GIẤY CAM KẾT TỪ CHỐI SỬ DỤNG DỊCH VỤ
                            <br />
                            KHÁM BỆNH, CHỮA BỆNH
                        </h2>

                        <h3 style={{ margin: "50px 0 10px 0" }}>I. THÔNG TIN CÁ NHÂN CỦA NGƯỜI KÝ</h3>
                        <p>
                            Tôi tên là: ...........................................................................
                            Năm sinh:............................&nbsp;&nbsp;
                            <input type="checkbox" /> Nam
                            &nbsp;&nbsp;
                            <input type="checkbox" /> Nữ
                        </p>
                        <p>
                            <input type="checkbox" /> Là người bệnh
                        </p>
                        <p>
                            <input type="checkbox" />&nbsp; 
                            Là ..................... của người bệnh ...........................................................................
                            Năm sinh:...............
                            <br />
                            Đang điều trị tại khoa: ............................................................Phòng:................. Giường:...........................
                        </p>

                        <h3 style={{ margin: "20px 0 10px 0" }}>II. NỘI DUNG</h3>

                        <p>
                            Phương pháp điều trị/chỉ định dự kiến thực hiện: .........................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            Tôi đã được giải thích về lợi ích của phương pháp điều trị dự kiến, những nguy cơ, đặc biệt là những rủi ro, biến chứng có thể xảy ra nếu từ chối điều trị hoặc sử dụng dịch vụ khám bệnh, chữa bệnh nêu trên.
                        </p>
                        <span>
                            Tôi xác nhận việc từ chối điều trị hoặc sử dụng dịch vụ y tế trên vào............giờ............
                            ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))}
                        </span>
                        <p className="signature-block">
                            <span></span>
                            <span></span>
                            <span>
                                <b>Người bệnh/thân nhân</b>
                                <br />
                                (Ký, ghi rõ họ tên)
                            </span>
                        </p>
                        <p style={{ marginTop: 70 }}>
                            Nguy cơ/ rủi ro: ..............................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            ........................................................................................................................................................................
                            <br />
                            Tôi xác nhận đã giải thích cho người bệnh/thân nhân của người bệnh về lợi ích, nguy cơ, biện pháp thay thế của việc từ chối sử dụng dịch vụ khám bệnh, chữa bệnh trên.

                        </p>

                        <p className="signature-block">
                            <span></span>
                            <span></span>
                            <span>
                                {/* Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))} */}
                                Ngày ........ tháng ........ năm ........
                                <br />
                                <b>Bác sỹ điều trị</b>
                                <br />
                                (Ký, ghi rõ họ tên)
                            </span>
                        </p>
                    </div>
                </div>

                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            html,
                            body {
                                margin: 0 auto;
                                padding: 0;
                            }
                        }
                        .print-container {
                            width: 100%;
                            font-family: "Times New Roman", serif;
                            font-size: 12pt;
                            line-height: 1.5;
                            color: #000;
                            page-break-after: always;
                            word-wrap: break-word;
                        }

                        /* ===== HEADER ===== */
                        .print-container .header {
                            display: grid;
                            grid-template-columns: 0.8fr 2fr 0.8fr;
                            /* cột giữa rộng hơn */
                            align-items: start;
                            column-gap: 4mm;
                            margin-bottom: 6mm;
                        }

                        .print-container .header-left {
                            font-size: 11pt;
                            line-height: 1.4;
                        }

                        .print-container .header-center {
                            text-align: center;
                        }

                        .print-container .header-title {
                            font-weight: bold;
                            font-size: 13pt;
                            line-height: 1.35;
                        }

                        .print-container .header-title .subtitle {
                            font-weight: normal;
                            font-size: 12pt;
                        }

                        .print-container .header-right {
                            text-align: right;
                            font-weight: bold;
                            font-size: 11pt;
                        }

                        /* ===== TITLE ===== */
                        .print-container .form-title {
                            text-align: center;
                            text-transform: uppercase;
                            font-size: 13pt;
                            font-weight: bold;
                            margin: 0;
                            line-height: 1.5;
                        }

                        .print-container .form-subtitle {
                            text-align: center;
                            margin-bottom: 5mm;
                        }

                        .print-container .form-subtitle label {
                            margin: 0 5mm;
                        }

                        /* ===== CONTENT ===== */
                        .print-container p {
                            margin: 0mm 0;
                            text-align: left;
                        }

                        .print-container ul.checklist {
                            list-style: none;
                            padding-left: 0;
                            margin: 2mm 0;
                        }

                        .print-container ul.checklist li {
                            margin-bottom: 2mm;
                        }

                        .print-container .checkbox-group {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 6mm;
                            margin-bottom: 3mm;
                        }

                        .print-container input[type="checkbox"] {
                            width: 18px;
                            height: 18px;
                            margin: 0;
                            position: relative;
                            bottom: -2px;
                        }

                        .print-container .checkbox-group label {
                            white-space: nowrap;
                        }

                        /* ===== SIGNATURE BLOCK ===== */
                        .print-container .signature-block {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr;
                            text-align: center;
                            margin-top: 2mm;
                            font-size: 12pt;
                        }

                        .print-container .signature-block span {
                            display: inline-block;
                            line-height: 1.6;
                        }

                        .print-container .line {
                            height: 5mm;
                            border-bottom: 0.3pt dotted #000;
                            margin: 0.8mm 0;
                        }

                        .w-150{
                            width: 150px;
                        }

                        .w-200{
                            width: 200px;
                        }

                        .text-indent{
                            text-indent: 20px;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintRefusa;
